import styled from "styled-components";

export const ActionButtonsContainer = styled.div(
  (props) => `
    background: #fff2d1;
    width: 75px;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    padding: 0px 6px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    box-shadow: 0 1px 8px 0 rgb(68 68 68 / 28%);

    ul.buttonWrap {
        color: #000;
        font-weight: 600;
        font-size: 12px;
        line-height: 12px;

        li.buttonOption {
            -webkit-box-direction: normal;
            align-items: center;
            flex-direction: column;
            flex-wrap: wrap;
            padding: 15px 0px;
            text-align: center;
            cursor: pointer;
            position: relative;
            display: flex;

            span.callBack {
                margin-bottom: 10px;
                width: 34px;
                height: 34px;
                background-position: -39px -109px;
                background-image: url("https://gos3.ibcdn.com/cabs_callback_img-1646656149.png");
                display: inline-block;
                background-size: 200px 200px !important;
                font-size: 0px;
                flex-shrink: 0;
            }
        }

    }
`
);